var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"call-to-action",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),_vm._v(" "),(_vm.icon)?_c('Avatar',{attrs:{"icon":_vm.icon,"color":_vm.iconColor,"rounded":_vm.iconRounded,"size":_vm.iconSize}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }